import { useRef } from 'react';
import { Component } from '../../data/rsTypes';
import { FlattenedComponentsRenderer } from '../ComponentsRenderer/FlattenedComponentsRenderer';
import { SignerComponentsRenderer } from '../ComponentsRenderer/SignerComponentsRenderer';
import { useAppStore } from '../store';
import { StyledOverlayerPage } from './OverLayerPage.styled';

interface Props {
	components: Component[];
	scale: number;
	pageNumber: number;
	signatureColor: string;
	pageHeight: number;
	pageWidth: number;
	maxPageHeight: number;
}

export type PageMetaDataType = {
	pageNumber: number;
	scale: number;
	pageHeight: number;
	pageWidth: number;
	maxPageHeight: number;
};

export const SignerOverlayerPage = (props: Props) => {
	const pageRef = useRef<HTMLDivElement>(null);

	const [selectedComponentId, setSelectedComponentId] = useAppStore(state => [
		state.selectedComponentId,
		state.setSelectedComponentId,
	]);
	const [signer, esignDocument, signers] = useAppStore(store => [
		store.signer,
		store.esignDocument,
		store.signers,
	]);

	const componentsToFill = props.components.filter(component => {
		return (
			component.assigned_to === signer.role_name &&
			!component.type.includes('Annotation') &&
			!component.is_merge_field
		);
	});

	const flattenedComponents = props.components.filter(component => {
		const componentSigner = signers?.find(s => s.role_name === component.assigned_to);
		return (
			component.type.includes('Annotation') ||
			component.is_merge_field ||
			(component.assigned_to !== signer.role_name &&
				esignDocument.signer_sequencing &&
				componentSigner?.status === 'signed')
		);
	});

	const pageBoundingBox = {
		width: props.pageWidth,
		height: props.maxPageHeight,
		actualPageHeight: props.pageHeight,
	};

	return (
		<StyledOverlayerPage
			ref={pageRef}
			id={`overlayer-page-${props.pageNumber}`}
			data-testid={`overlayer-page-${props.pageNumber}`}
			onClick={() => setSelectedComponentId(null)}
		>
			<SignerComponentsRenderer
				components={componentsToFill}
				pageBoundingBox={pageBoundingBox}
				selectedComponentId={selectedComponentId}
				setSelectedComponentId={setSelectedComponentId}
				signatureColor={props.signatureColor}
			/>
			<FlattenedComponentsRenderer
				components={flattenedComponents}
				pageBoundingBox={pageBoundingBox}
				signatureColor={props.signatureColor}
			/>
		</StyledOverlayerPage>
	);
};
